import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import BrandMark from "../components/BrandMark";
import { COMPANY } from "../lib/company";

export default function ConsentText() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-black/10">
        <div className="max-w-screen-xl mx-auto px-8 py-5 flex items-center justify-between">
          <BrandMark />
          <Link to="/" className="hop-link text-sm">← на главную</Link>
        </div>
      </header>

      <main className="flex-1">
        <article className="max-w-3xl mx-auto px-8 py-16 md:py-24">
          <div className="label-mono">152-ФЗ · СОГЛАСИЕ</div>
          <h1 className="mt-3 text-4xl md:text-5xl tracking-tight font-medium">
            Согласие на обработку<br />персональных данных
          </h1>
          <p className="mt-4 text-foreground/60 mono text-xs">Редакция от 29 апреля 2026 г.</p>

          <div className="mt-12 space-y-6 text-foreground/85 leading-relaxed">

            <p>
              Я, заполняя анкету диагностического сервиса Hop&nbsp;·&nbsp;Diagnostic
              (домен {COMPANY.service.domain}, далее — Сервис), действуя своей волей и в&nbsp;своём интересе,
              в&nbsp;соответствии с&nbsp;Федеральным законом от&nbsp;27.07.2006 №&nbsp;152-ФЗ
              «О&nbsp;персональных данных», предоставляю своё согласие
              {" "}{COMPANY.legalName} (ИНН {COMPANY.inn}, ОГРН {COMPANY.ogrn},
              юридический адрес: {COMPANY.address}) (далее — Оператор)
              на&nbsp;обработку моих персональных данных на&nbsp;следующих условиях.
            </p>

            <Block num="01" title="Обрабатываемые персональные данные">
              имя контактного лица стартапа; адрес электронной почты; телефон (если указан);
              псевдоним в&nbsp;Telegram (если указан); название и&nbsp;сайт стартапа; ответы
              на&nbsp;вопросы анкеты, включая открытые текстовые описания проекта; технические
              данные посещений (IP-адрес, версия браузера, отметки времени, технические cookie).
            </Block>

            <Block num="02" title="Цели обработки">
              расчёт диагностических индексов готовности стартапа и&nbsp;формирование рекомендаций;
              хранение результата подачи анкеты и&nbsp;предоставление мне доступа к&nbsp;нему;
              статистический и&nbsp;методологический анализ выборки в&nbsp;обезличенном виде
              для совершенствования методики; связь со&nbsp;мной по&nbsp;поводу поданной мной анкеты, если
              это необходимо.
            </Block>

            <Block num="03" title="Перечень действий с данными">
              сбор, запись, систематизация, накопление, хранение, уточнение, использование,
              обезличивание, блокирование, удаление, уничтожение — как с&nbsp;использованием
              средств автоматизации, так и&nbsp;без них.
            </Block>

            <Block num="04" title="Передача данных третьим лицам">
              Оператор вправе передавать персональные данные третьим лицам
              в&nbsp;случаях, предусмотренных законодательством Российской Федерации,
              а&nbsp;также партнёрам Оператора, участвующим в&nbsp;реализации проекта
              (в&nbsp;том числе для&nbsp;целей организации мероприятий, обработки заявок,
              предоставления пользователям материалов и&nbsp;иной деятельности,
              связанной с&nbsp;проектом) и&nbsp;поставщикам языковых моделей в&nbsp;рамках,
              описанных в&nbsp;разделе 05 Политики обработки персональных данных,
              при&nbsp;условии соблюдения требований законодательства Российской Федерации
              о&nbsp;персональных данных.
            </Block>

            <Block num="05" title="Срок действия согласия и хранения">
              Настоящее согласие действует {COMPANY.retentionMonths} месяцев с&nbsp;момента отправки анкеты.
              По&nbsp;истечении срока персональные данные удаляются или&nbsp;обезличиваются.
              Я&nbsp;вправе отозвать настоящее согласие в&nbsp;любое время путём направления
              письменного уведомления на&nbsp;адрес <a className="hop-link" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
            </Block>

            <Block num="06" title="Подтверждаю, что я ознакомлен(а)">
              с&nbsp;Политикой обработки персональных данных Оператора
              (доступна по&nbsp;адресу https://{COMPANY.service.domain}/privacy),
              понимаю объём, цели и&nbsp;последствия обработки. Согласие даётся свободно
              и&nbsp;может быть отозвано без указания причин.
            </Block>

          </div>

          <div className="mt-12 border-t border-black/10 pt-8 text-sm text-foreground/70 leading-relaxed">
            Подтверждение настоящего согласия осуществляется проставлением отметки
            в&nbsp;соответствующем чекбоксе на&nbsp;экране согласий перед заполнением
            анкеты, что в&nbsp;соответствии с&nbsp;ч.&nbsp;1 ст.&nbsp;9 152-ФЗ
            является надлежащей формой выражения согласия в&nbsp;форме электронного документа,
            подтверждённого простым актом действия пользователя.
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}

function Block({ num, title, children }) {
  return (
    <div>
      <div className="flex items-baseline gap-3">
        <div className="label-mono">{num}</div>
        <div className="font-medium">{title}</div>
      </div>
      <p className="mt-2 ml-12 md:ml-14">{children}</p>
    </div>
  );
}
